import React, { type ComponentType } from 'react';
import { ImageIcon, Share2Icon, FileTextIcon, MailIcon, ArrowRightIcon } from 'lucide-react';
import { SectionHeading } from './Section';
import { tools, type ToolItem } from '../../../data/reportPhilly';
const iconMap: Record<ToolItem['icon'], ComponentType<{
  className?: string;
}>> = {
  ad: ImageIcon,
  social: Share2Icon,
  script: FileTextIcon,
  email: MailIcon
};
// Cabernet-branded toolkit — "Property Marketing Toolkit".
export function ToolkitV5() {
  return <section className="print:hidden" data-id="element-850" data-mp="4orpw520o6hj">
      <SectionHeading eyebrow="Keep the momentum going" title="Property Marketing Toolkit" description="Grab any asset to repost, forward, or send to someone who might know the perfect buyer." data-id="element-851" data-mp="4puf88joy0vc" />
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4" data-id="element-852" data-mp="1uznq4yglxby9">
        {tools.map(tool => {
        const Icon = iconMap[tool.icon];
        return <button key={tool.title} type="button" className="group flex h-full flex-col gap-3 border border-border bg-card p-5 text-left transition-all hover:-translate-y-0.5 hover:border-bhhs-cab/40 hover:shadow-lg" data-id="element-853" data-mp="1q35jtu5mp5jt">
              <span className="flex size-10 items-center justify-center bg-bhhs-cab text-white" data-id="element-854" data-mp="1i9ab0il1nic5">
                <Icon className="size-4" data-id="element-855" data-mp="1m9kijzohigt4" />
              </span>
              <div className="flex-1" data-id="element-856" data-mp="pkmko8lfu2rq">
                <p className="text-sm font-semibold" data-id="element-857" data-mp="plo7197wmbor">{tool.title}</p>
                <p className="mt-1 text-xs text-muted-foreground" data-id="element-858" data-mp="ujzgvjy78m6z">
                  {tool.description}
                </p>
              </div>
              <span className="inline-flex items-center gap-1 text-sm font-medium text-bhhs-cab" data-id="element-859" data-mp="yif3vnua5uke">
                {tool.cta}
                <ArrowRightIcon className="size-4 transition-transform group-hover:translate-x-0.5" data-id="element-860" data-mp="6tllpkkbi786" />
              </span>
            </button>;
      })}
      </div>
    </section>;
}